import React from 'react'
import styled from 'styled-components'

function About_Vision_Misson() {
  return (
    <Wrapper>
        <div>
            <h3>Vision</h3>
            <p>To nurture confident, competent and compassionate learners by providing a supportive learning environment that promotes academic excellence, moral values, life skills and holistic development, enabling students to become a responsible global citizens.</p>
            <h3>Mission</h3>
            <p>To deliver quality education through learner-centric and inclusive teaching practices.</p>
                <p>To foster critical thinking, creativity and problem solving skills among students.</p>
                <p>To promote moral values, discipline and respect for diversity.</p>
                <p>To encourage participation in co-curricular, sports and life skills activities for all round development.</p>
                <p>To continuously enhance institutional quality through teacher development, innovation, and reflective practices.</p>
        </div>
    </Wrapper>
  )
}
const Wrapper = styled.section`
  p{
    font-size:2.3rem;
    line-height:1.1 
  }

`
export default About_Vision_Misson